import PdfDownloadController from "./pdf_download_controller"

// 선택 항목 일괄 PDF 다운로드 (경고표지 목록의 [선택 경고표지 다운로드]).
//
// checkbox-select 의 item 체크박스(:checked) 에서 제품 코드를 모아, 기존 단일
// 파이프라인(POST /workplace/pdf_jobs → 폴링 → 다운로드)을 **순차** 실행한다.
// 경고표지는 제품마다 용지 크기가 달라(Chromium 은 문서 내 페이지별 크기 미지원)
// PDF 합본이 불가 → 제품당 PDF 1개씩 개별 다운로드.
//
// 사용 예시 (view):
//   <button data-controller="bulk-pdf-download"
//           data-bulk-pdf-download-kind-value="warning_label"
//           data-action="click->bulk-pdf-download#start">선택 다운로드</button>
//   <%= render 'shared/pdf_download_modal' %>
export default class extends PdfDownloadController {
  async start(event) {
    if (event) event.preventDefault()
    if (this.busy) return

    // 선택된 체크박스에서 코드 수집 — 경고표지 미생성(has-label=false) 제품은 스킵.
    const checked = Array.from(
      document.querySelectorAll('[data-checkbox-select-target="item"]:checked')
    )
    const codes = checked
      .filter((cb) => cb.dataset.hasLabel === "true")
      .map((cb) => cb.value)
    const skipped = checked.length - codes.length

    if (codes.length === 0) {
      this.openModal()
      this.showError("선택한 제품에 생성된 경고표지가 없습니다. 경고표지를 먼저 생성해 주세요.")
      return
    }

    this.busy = true
    this.toggleTriggers(false)
    const failed = []

    try {
      this.openModal()
      for (let i = 0; i < codes.length; i++) {
        this.showSpinner(`경고표지 PDF 다운로드 중... (${i + 1}/${codes.length})`)
        try {
          await this.downloadOne(codes[i])
        } catch (e) {
          failed.push(codes[i])
        }
        await this.sleep(300) // 연속 다운로드 간 간격 — 브라우저 다중 다운로드 안정화
      }

      if (failed.length > 0) {
        this.showError(
          `일부 다운로드에 실패했습니다 (${failed.length}건): ${failed.join(", ")}` +
            (skipped > 0 ? ` — 경고표지 미생성 ${skipped}건은 제외되었습니다.` : "")
        )
      } else if (skipped > 0) {
        // 전부 성공했지만 미생성 제외분이 있으면 조용히 닫지 않고 안내 (혼란 방지).
        this.showError(`다운로드 완료. 경고표지 미생성 ${skipped}건은 제외되었습니다.`)
      } else {
        this.closeModal()
      }
    } finally {
      this.busy = false
      this.toggleTriggers(true)
    }
  }

  // 단일 코드 다운로드 — 부모 start() 의 요청부와 동일하나 code 를 인자로 받는다.
  async downloadOne(code) {
    const res = await fetch("/workplace/pdf_jobs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken(),
        "Accept": "application/json"
      },
      body: JSON.stringify({ kind: this.kindValue, code: code })
    })
    const json = await res.json()
    if (!res.ok || !json.success) {
      throw new Error(this.errorLabel(json) || "PDF 생성 요청에 실패했습니다.")
    }
    await this.poll(json.data.status_url, json.data.download_url, 0)
  }

  // 부모 poll 오버라이드 — completed 시 모달을 닫지 않고(다음 항목이 이어짐)
  // 다운로드만 트리거한다. 모달 close 는 루프 종료 후 start() 가 판단.
  async poll(statusUrl, downloadUrl, attempt) {
    if (attempt >= this.maxAttemptsValue) {
      throw new Error("PDF 생성 시간이 초과되었습니다.")
    }
    await this.sleep(this.pollIntervalValue)

    const res = await fetch(statusUrl, {
      headers: { "Accept": "application/json", "X-CSRF-Token": this.csrfToken() }
    })
    const json = await res.json()
    if (!res.ok || !json.success) {
      throw new Error(this.errorLabel(json) || "상태 조회에 실패했습니다.")
    }

    const { status, error } = json.data
    if (status === "completed") {
      this.triggerDownload(downloadUrl)
      return
    }
    if (status === "failed") {
      throw new Error(error || "PDF 생성에 실패했습니다.")
    }
    return this.poll(statusUrl, downloadUrl, attempt + 1)
  }

  // 부모는 pdf-download 트리거들을 일괄 토글 — bulk 는 자기 버튼만.
  toggleTriggers(enabled) {
    if (enabled) this.element.removeAttribute("disabled")
    else this.element.setAttribute("disabled", "true")
  }
}
